// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZYlt","title":"styles_title__1Lgat"};